import api from '@/api/index.js'

const account_taps = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_ACCOUNT_TAPS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_TAPS: (state, response) => {
      state.data = response
      state.loading = false;
    },
    SET_ACCOUNT_TAPS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetAccountTaps({commit}, id) {
      commit('SET_ACCOUNT_TAPS_LOADING', true)
      return api.get(`accounts/${id}/taps?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_TAPS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_TAPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_taps
